<template>
  <b-container fluid :id="content[0].section" class="section my-5">         
    <b-row class="dark-color text-white">
      <b-col cols="12" lg="6" class="px-5 pt-5 text-right-lg dark-color text-white">
        <div class="py-3">
          <h2 class="display-4 upper bold">{{ content[0].title }}<br>
          <span class="text-blue">{{ content[0].subtitle }}</span></h2>
        </div>
      </b-col>

      <b-col cols="12" lg="6" class="p-5">
        <div class="py-3">
            <div class="w-100 mb-5 hr-theme-slash">
              <div class="hr-line"></div>
              <div class="hr-icon"><font-awesome-icon :icon="content[0].icon" size="3x"/></div>
              <div class="hr-line"></div>
            </div>

            <p v-for="(paragraph, index) in content[0].text" v-bind:key="'p' + index">
                {{ paragraph }}
            </p>

            <div class="text-center w-100 mt-5">
              <div
                v-for="cta in content[0].cta"
                v-bind:key="'cta-' + cta.name"
              >
                <b-button
                  block
                  v-if="cta.action"
                  class="btn-cta p-3 upper my-2" 
                  @click="runMethod(cta.action)"
                >
                  {{ cta.text }}
                </b-button>

                <b-button
                  block
                  v-else
                  class="btn-cta p-3 upper my-2" 
                  :to="cta.link"
                >
                  {{ cta.text }}
                </b-button>
              </div>
            </div>
        </div>
      </b-col>
    </b-row>    
  </b-container>
</template>

<script>
export default {
  name: 'Section',
  props: [
    'content'
  ],
  methods: {
    runMethod(method) {
      this[method]()
    },
    sendMessage() {
      this.$emit('sendMessage')
    }
  }
}
</script>

<style scoped>
.section > .row {
    min-height: 50vh;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
}

.background {
  height: 100%;
  width: 100%;
  z-index: 5;
}

.content {
  position: relative;
  z-index: 10;
}

.hr-theme-slash {
  display: flex;
}
  
.hr-theme-slash > .hr-line {
  width: 100%;
  position: relative;
  margin: 15px;
  border-bottom: 3px solid #fff;
}

.hr-theme-slash > .hr-icon {
  position: relative;
  top: 3px;
  color: #fff;
}
</style>
